@if (esRaiz) {
  <button
    irxBotonIcono
    tamano="mini"
    class="copy-full-button"
    tooltip="Copiar todo el JSON"
    (click)="copyJson()"
  >
    <span class="material-icons">content_copy</span>
  </button>
}

<ul class="json-tree" [class.raiz]="esRaiz">
  @for (key of objectKeys(data); track key) {
    <li class="json-item">
      @if (esExpandible(data[key])) {
        <div
          class="fila toggle irx-clickeable"
          role="button"
          tabindex="0"
          (click)="toggle(path + '.' + key)"
          (keydown.enter)="toggle(path + '.' + key)"
        >
          <span
            class="caret"
            [class.abierto]="isExpanded(path + '.' + key)"
          ></span>
          <span class="clave">{{ etiquetaClave(key) }}</span>
          <span class="cantidad">{{ cantidad(data[key]) }}</span>
        </div>
        @if (isExpanded(path + '.' + key)) {
          <div class="nested">
            <app-json-tree
              [data]="data[key]"
              [path]="path + '.' + key"
              [expanded]="expanded"
            ></app-json-tree>
          </div>
        }
      } @else {
        <div class="fila hoja copy-container">
          <span class="sangria"></span>
          <span class="clave">{{ etiquetaClave(key) }}</span>
          <span class="valor" [class]="claseValor(data[key])">
            @if (isEmptyObject(data[key])) {
              {{ etiquetaVacio(data[key]) }}
            } @else {
              {{ textoValor(data[key]) }}
            }
          </span>
          <button
            irxBotonIcono
            tamano="mini"
            class="copy-button"
            tooltip="Copiar valor"
            (click)="copyValue(data[key])"
          >
            <span class="material-icons">content_copy</span>
          </button>
        </div>
      }
    </li>
  }
</ul>
